import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';

const DeletePage = lazy(() => import('./pages/delete'));
const EditPage = lazy(() => import('./pages/edit'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/suppliers',
    title: 'Dobavljači',
    Component: IndexPage,
    children: [{
        Component: ModalOutlet,
        children: [{
            path: 'add',
            Component: EditPage,
        }, {
            path: ':supplierId',
            children: [{
                path: 'edit',
                Component: EditPage,
            }, {
                path: 'delete',
                Component: DeletePage,
            }],
        }],
    }],
} satisfies RouteObject;
